<template>
  <div class="broadcast_box">
    <div class="broadcast_header">
      <div class="names" :class="{ 'no-arrow': !item.show }">
        <h2 class="broadcast_name" :class="{ 'no-arrow': !item.show }">
          <router-link :to="{ name: 'broadcast', params: { id: item._id } }">
            {{ item.name }}
          </router-link>
          <label>
            <span>(bcId: {{item._id}})</span>
          </label>
          <a v-if="isPairingDetails" @click="openPairingDetails()" class="pairing_info" title="Zobrazit informace o párování">Zobrazit informace o párování</a>
        </h2>
        <h2 v-if="item.show" class="show_name">
          <router-link :to="{ name: 'show', params: { id: item.show._id } }">
            <template>
              {{ item.show.name || item.show.originalName || item.show.firstTranslationName }}
            </template>
          </router-link>
          <template v-if="item.episode">
            {{ getEpisodeTitle(item.episode) }}
          </template>
          <label>
            <span>(showId: {{item.show._id}})</span>
          </label>
        </h2>
        <a
          class="btn btn_action btn_delete"
          :title="translations.unassign"
          v-if="item.show"
          @click.prevent="$emit('delete', item)"
        />
      </div>
      <div class="broadcast_time">
        <span>
          {{ formatDateBroadcast(item.start) }} | {{ item.tvStation.name }}
        </span>
        <app-status-indicator class="program-item-status" :status="getStatusIndicator(item.state)" />
      </div>
    </div>
    <div class="original_data">
      <h3>Info o broadcastu</h3>
      <ul>
        <li v-for="(value, key) in originalDescription" v-if="value">
          <strong>{{ key }}</strong>
          <span>{{ value }}</span>
        </li>
      </ul>
      <strong v-if="item.descriptionShort">{{ translations.shortDescription }}</strong>
      <p class="description1" v-if="item.descriptionShort">
        {{ item.descriptionShort | shortenDescription }}
      </p>
      <strong v-if="item.descriptionLong">{{ translations.longDescription }}</strong>
      <p class="description2" v-if="item.descriptionLong">
        {{ item.descriptionLong | shortenDescription }}
      </p>
    </div>
    <div class="final_data">
      <div class="description_box">
        <h3>Info o pořadu</h3>
        <ul>
          <template v-if="item.show">
            <li v-for="(value, key) in showDescription">
              <strong>{{ key }}</strong>
              <span>{{ value }}</span>
            </li>
          </template>
          <li>
            <strong>{{translations.importTags}}</strong>
            <span>
              <template v-for="label in item.importLabels">
                <span :key="label._id" class="tag">{{ label }}</span>&nbsp;
              </template>
            </span>
          </li>
          <li v-if="item.show">
            <strong>{{translations.dbTags}}</strong>
            <span>
              <span v-if="item.show.formatLabelId" class="tag">
                {{ labels[item.show.formatLabelId] }}
              </span>&nbsp;
              <template v-if="item.show.contentLabelIds.length > 0" v-for="label in item.show.contentLabelIds">
                <span :key="label._id" class="tag">{{ labels[label] }}</span>&nbsp;
              </template>
            </span>
          </li>
          <li v-else>
            <strong>{{translations.dbTags}}</strong>
            <span>
              <span v-if="item.formatLabelId" class="tag">
                {{ labels[item.formatLabelId] }}
              </span>&nbsp;
              <template v-if="item.contentLabelIds.length > 0" v-for="label in item.contentLabelIds">
                <span :key="label._id" class="tag">{{ labels[label] }}</span>&nbsp;
              </template>
            </span>
          </li>
        </ul>
        <strong v-if="item.show && item.show.leadParagraph">{{ translations.shortDescription }}</strong>
        <p v-if="item.show && item.show.leadParagraph">
          {{ item.show.leadParagraph | shortenDescription }}
        </p>
        <strong v-if="item.show && item.show.description">{{ translations.longDescription }}</strong>
        <p v-if="item.show && item.show.description">
          {{ item.show.description | shortenDescription }}
        </p>

      </div>
      <div class="poster_box" v-if="item.show">
        <image-item
            :image="item.show.primaryPortrait"
            imageClass="poster"
            textClass="poster_text"
        />
        <image-item
            :image="item.show.primaryLandscape"
            imageClass="photo"
            textClass="photo_text"
        />
        <image-item
            v-if="item.show.youtubeLink"
            imageClass="trailer"
            :youtubeLink="item.show.youtubeLink"
        />
      </div>

      <div class="poster_box" v-else>
        <image-item
            :image="item.primaryPortrait"
            imageClass="poster"
            textClass="poster_text"
        />
        <image-item
            :image="item.primaryLandscape"
            imageClass="photo"
            textClass="photo_text"
        />
      </div>
    </div>
    <span class="periodicity periodic" v-if="item.show && item.show.isPeriodic" :title="translations.periodicShow">
      <translate>Periodický pořad</translate>
    </span>
    <span class="periodicity disposable" v-else-if="item.show && item.show.isPeriodic === false" :title="translations.nonperiodicShow">
      <translate>Jednorázový pořad</translate>
    </span>
  </div>
</template>

<script>
import ImageItem from './ImageItem'
import formatDateMixin from '../../mixins/formatDateMixin'
import Templates from '../Show/Common/Templates'

export default {
  name: 'program-item',
  components: {
    Templates,
    ImageItem
  },
  mixins: [formatDateMixin],
  props: {
    item: {
      type: Object,
      required: true
    },
    labels: {
      type: Object,
      required: true
    },
    countries: {
      type: Array,
      required: true
    }
  },
  computed: {
    translations() {
      return {
        unassign: this.$gettext('Zrušit navázání'),
        periodicShow: this.$gettext('Periodický pořad'),
        nonperiodicShow: this.$gettext('Jednorázový pořad'),
        dbTags: this.$gettext('Štítky z databáze:'),
        importTags: this.$gettext('Importní štítky:'),
        labels: this.$gettext('Štítky:'),
        country: this.$gettext('Stát:'),
        year: this.$gettext('Rok:'),
        yearStart: this.$gettext('Rok od:'),
        yearEnd: this.$gettext('Rok do:'),
        duration: this.$gettext('Stopáž:'),
        rating: this.$gettext('Hodnocení:'),
        episodeName: this.$gettext('Název epizody:'),
        shortDescription: this.$gettext('Krátký popis'),
        longDescription: this.$gettext('Dlouhý popis'),
        importId: this.$gettext('Import ID:'),
        showInRails: this.$gettext('Rail carousel: '),
      }
    },
    originalDescription() {
      const obj = {}
      if (this.item) {
        obj[this.translations.labels] = this.item.labels ? this.item.labels : ''
        obj[this.translations.country] = this.broadcastCountries ? this.broadcastCountries : ''
        obj[this.translations.year] = this.item.year ? this.item.year : ''
        obj[this.translations.duration] = this.item.durationMinutes ? `${this.item.durationMinutes} min` : ''
        obj[this.translations.rating] = this.item.rating ? this.item.rating + '%' : ''
        obj[this.translations.episodeName] = this.item.episodeName ? this.item.episodeName : ''
        obj[this.translations.importId] = this.item.importId ? this.item.importId : ''
        obj[this.translations.showInRails] = this.item.showInRail ? 'Ano ' + (this.item.railPriority > 0 ? ' | Priority: ' + this.item.railPriority : '') : null
      }
      return obj
    },
    showDescription() {
      const data = this.item.show
      const obj = {}
      if (data) {
        obj[this.translations.yearStart] = data.yearStart ? data.yearStart : ''
        obj[this.translations.yearEnd] = data.yearEnd ? data.yearEnd : ''
        obj[this.translations.duration] = data.duration ? `${data.duration} min` : ''
        obj[this.translations.rating] = data.rating ? data.rating + '%' : ''
      }
      return obj
    },
    broadcastCountries() {
      let countries = ''

      for (let i = 0; i < this.item.countryIds.length; i++) {
        for (let j = 0; j < this.countries.length; j++) {
          if (this.item.countryIds[i] === this.countries[j]._id && this.countries[j].isoCode) {
            countries += this.countries[j].isoCode.toUpperCase()
            if (i + 1 !== this.item.countryIds.length) {
              countries += ', '
            }
          }
        }
      }

      return countries
    },
    isPairingDetails() {
      return this.item.pairingDetails.length === undefined
    }
  },
  methods: {
    getStatusIndicator(broadcastState) {
      switch (broadcastState) {
        case 'BROADCAST_STATE_UNASSIGNED':
          return 'red'
        case 'BROADCAST_STATE_UNVERIFIED':
          return 'orange'
        case 'BROADCAST_STATE_VERIFIED':
          return 'green'
        default:
          return 'pending'
      }
    },
    getEpisodeTitle(episode) {
      const seriesNum = String(episode.seriesNumber).padStart(2, '0')
      const episodeNum = String(episode.episodeNumber).padStart(2, '0')
      return ` / s${seriesNum}e${episodeNum} ${episode.name}`
    },
    openPairingDetails() {
      this.$emit('openPairingDetails', this.item)
    }
  }
}
</script>
